import { Box } from "@mui/material";

type ImagePreviewBoxProps = {
  previewUrl: string | null;
  alt?: string;
};

const ImagePreviewBox = ({ previewUrl, alt = "" }: ImagePreviewBoxProps) => {
  return (
    <Box
      sx={{
        width: 100,
        height: 100,
        border: "1px solid",
        borderColor: "divider",
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "action.hover",
        overflow: "hidden",
      }}
    >
      {previewUrl ? (
        <Box
          component="img"
          src={previewUrl}
          alt={alt}
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      ) : (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            position: "relative",
            bgcolor: "grey.100",
            "&::before, &::after": {
              content: '""',
              position: "absolute",
              bgcolor: "grey.400",
              transformOrigin: "center",
            },
            "&::before": {
              width: "141%",
              height: "1px",
              top: "50%",
              left: "-20%",
              transform: "rotate(45deg)",
            },
            "&::after": {
              width: "141%",
              height: "1px",
              top: "50%",
              left: "-20%",
              transform: "rotate(-45deg)",
            },
          }}
        />
      )}
    </Box>
  );
};

export default ImagePreviewBox;
